/** Comparator function, takes two arguments and compares them,
 * as in https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
 */
type ComparatorFn<T> = (a: T, b: T) => number;

/** Sorter function - alphabetical on string property */
export const sortByStringProp: <T = any>(key: string) => ComparatorFn<T> = (
  key
) => (a, b) => {
  if (a === b) {
    return 0;
  }
  if (typeof a === typeof b) {
    return a < b ? -1 : 1;
  }
  return typeof a < typeof b ? -1 : 1;
};

/** Sorter function - numeric order */
export const sortByNumberProp: <T = any>(key: string) => ComparatorFn<T> = (
  key
) => (a, b) => {
  return a[key] - b[key];
};
